import { render, staticRenderFns } from "./commodity-list.html?vue&type=template&id=8272e76c&scoped=true&"
import script from "./commodity-list.js?vue&type=script&lang=js&"
export * from "./commodity-list.js?vue&type=script&lang=js&"
import style0 from "./CommodityList.vue?vue&type=style&index=0&id=8272e76c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8272e76c",
  null
  
)

component.options.__file = "CommodityList.vue"
export default component.exports